// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.t2VdZ3jftkuZj_mZ9jKn {
  margin-top: 10px;
}

/*--------------------TabPanel--------------------*/

.DBIqDBCyc0tNRQNVlRCa {
  padding: 4px;
  border-radius: 12px;
  background: rgb(var(--secondary-bg));
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  position: relative;
}

.wZliUS_Z4bYZsh05g_kQ {
  font-family: Inter;
  padding: 9px 12px;
  height: auto;
  background: transparent;
  border: none;
  outline: none;
  font-size: 14px;
  font-weight: 400;
  line-height: 128%;
  width: 100%;
  color: rgb(var(--placeholder-primary));
  border-radius: 12px;
  cursor: pointer;
  z-index: 5;
}

.QtGdvnr9k54zk5gQaUrB {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-157%, -50%);
  /* -157% / -50% /  57% */
  width: calc(33% - 8px) ; 
  height: calc(100% - 8px);
  border-radius: 12px;
  background: rgb(var(--accent-brand));
  z-index: 4;

}

.wZliUS_Z4bYZsh05g_kQ:hover {
  background: transparent;
}

.g9lQeOSbtZIOp7hcH245:hover {
  background: rgb(var(--accent-brand));
}

@media (max-width: 350px) {
  .U2mqdcZbfS7HBkLpqxaL {
    font-size: 16px;
    padding: 4.6px 10px;
  }
}

/*--------------------/TabPanel--------------------*/

/* deploy wallet panel */

.g72VaSvRHc0OCnFoXhxh {
  padding: 18px 16px 16px 16px;
  border-radius: 16px;
  background: rgb(var(--secondary-bg));
  background: linear-gradient(0deg, rgba(var(--secondary-bg), 0.40) 0%, rgba(var(--secondary-bg), 0.40) 100%), rgb(var(--tertiary-bg));
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 16px;
  gap: 7px;
}

.RxMn4xV3_a8dJNChRlxU {
  display: flex;
  align-items: center;
  gap: 16px;
}

.ZeysgZTWFj5yyqxWjuej {
  font-size: 14px;
  font-weight: 410;
}

.wpfGpEjtkpfhwE4jWHsQ {
  margin-top: 12px;
  font-size: 15px;
  font-weight: 540;
  padding: 14px;
  border-radius: 12px;
  min-width: 250px;
  background: rgba(var(--placeholder-primary-dark), 0.10);
  border: none;
  box-shadow: none;
  color: rgb(var(--placeholder-primary));
  cursor: pointer;
  transition: background 0.3s ease 0s;
}

.wpfGpEjtkpfhwE4jWHsQ:hover {
  background: rgba(var(--placeholder-primary-dark), 0.20);
}


@media (max-width: 450px) {
  .wpfGpEjtkpfhwE4jWHsQ {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/main/main.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA,mDAAmD;;AAEnD;EACE,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,sCAAsC;EACtC,mBAAmB;EACnB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,iCAAiC;EACjC,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,mBAAmB;EACnB,oCAAoC;EACpC,UAAU;;AAEZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA,oDAAoD;;AAEpD,wBAAwB;;AAExB;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,oCAAoC;EACpC,oIAAoI;EACpI,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,uDAAuD;EACvD,YAAY;EACZ,gBAAgB;EAChB,sCAAsC;EACtC,eAAe;EACf,mCAAmC;AACrC;;AAEA;EACE,uDAAuD;AACzD;;;AAGA;EACE;IACE,WAAW;EACb;AACF","sourcesContent":[".mainPage {\n  margin-top: 10px;\n}\n\n/*--------------------TabPanel--------------------*/\n\n.tabPanel {\n  padding: 4px;\n  border-radius: 12px;\n  background: rgb(var(--secondary-bg));\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 16px;\n  position: relative;\n}\n\n.tabButton {\n  font-family: Inter;\n  padding: 9px 12px;\n  height: auto;\n  background: transparent;\n  border: none;\n  outline: none;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 128%;\n  width: 100%;\n  color: rgb(var(--placeholder-primary));\n  border-radius: 12px;\n  cursor: pointer;\n  z-index: 5;\n}\n\n.tabButtonDiv {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-157%, -50%);\n  /* -157% / -50% /  57% */\n  width: calc(33% - 8px) ; \n  height: calc(100% - 8px);\n  border-radius: 12px;\n  background: rgb(var(--accent-brand));\n  z-index: 4;\n\n}\n\n.tabButton:hover {\n  background: transparent;\n}\n\n.tabButtonActive:hover {\n  background: rgb(var(--accent-brand));\n}\n\n@media (max-width: 350px) {\n  .actionButton {\n    font-size: 16px;\n    padding: 4.6px 10px;\n  }\n}\n\n/*--------------------/TabPanel--------------------*/\n\n/* deploy wallet panel */\n\n.deployPanel {\n  padding: 18px 16px 16px 16px;\n  border-radius: 16px;\n  background: rgb(var(--secondary-bg));\n  background: linear-gradient(0deg, rgba(var(--secondary-bg), 0.40) 0%, rgba(var(--secondary-bg), 0.40) 100%), rgb(var(--tertiary-bg));\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  margin-bottom: 16px;\n  gap: 7px;\n}\n\n.deployPanelInner {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.errorText {\n  font-size: 14px;\n  font-weight: 410;\n}\n\n.deployBtn {\n  margin-top: 12px;\n  font-size: 15px;\n  font-weight: 540;\n  padding: 14px;\n  border-radius: 12px;\n  min-width: 250px;\n  background: rgba(var(--placeholder-primary-dark), 0.10);\n  border: none;\n  box-shadow: none;\n  color: rgb(var(--placeholder-primary));\n  cursor: pointer;\n  transition: background 0.3s ease 0s;\n}\n\n.deployBtn:hover {\n  background: rgba(var(--placeholder-primary-dark), 0.20);\n}\n\n\n@media (max-width: 450px) {\n  .deployBtn {\n    width: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainPage": `t2VdZ3jftkuZj_mZ9jKn`,
	"tabPanel": `DBIqDBCyc0tNRQNVlRCa`,
	"tabButton": `wZliUS_Z4bYZsh05g_kQ`,
	"tabButtonDiv": `QtGdvnr9k54zk5gQaUrB`,
	"tabButtonActive": `g9lQeOSbtZIOp7hcH245`,
	"actionButton": `U2mqdcZbfS7HBkLpqxaL`,
	"deployPanel": `g72VaSvRHc0OCnFoXhxh`,
	"deployPanelInner": `RxMn4xV3_a8dJNChRlxU`,
	"errorText": `ZeysgZTWFj5yyqxWjuej`,
	"deployBtn": `wpfGpEjtkpfhwE4jWHsQ`
};
export default ___CSS_LOADER_EXPORT___;
